import { render, staticRenderFns } from "./CeldaChips.vue?vue&type=template&id=17f4d6be&scoped=true"
import script from "./CeldaChips.vue?vue&type=script&lang=js"
export * from "./CeldaChips.vue?vue&type=script&lang=js"
import style0 from "./CeldaChips.vue?vue&type=style&index=0&id=17f4d6be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f4d6be",
  null
  
)

export default component.exports